const EDITOR_LIST_LOCAL_STORAGE_KEY = '@editorList';

export { EDITOR_LIST_LOCAL_STORAGE_KEY };
